package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Eswatini Flag (16x12dp)
 *
 * - ISO Alpha-2: SZ
 * - ISO Alpha-3: SWZ
 * - ISO Numeric: 748
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.Eswatini: ImageVector by lazy {
    ImageVector.Builder(
        name = "Eswatini:SZ:SWZ:748:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF3D58DB)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(16f)
                verticalLineTo(12f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                stroke = SolidColor(Color(0xFFFFD018)),
                strokeLineWidth = 1f
            ) {
                moveTo(0f, 2.5f)
                horizontalLineTo(-0.5f)
                verticalLineTo(3f)
                verticalLineTo(9f)
                verticalLineTo(9.5f)
                horizontalLineTo(0f)
                horizontalLineTo(16f)
                horizontalLineTo(16.5f)
                verticalLineTo(9f)
                verticalLineTo(3f)
                verticalLineTo(2.5f)
                horizontalLineTo(16f)
                horizontalLineTo(0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(3.575f, 4.666f)
                curveTo(3.515f, 4.666f, 3.466f, 4.53f, 3.466f, 4.363f)
                curveTo(3.466f, 4.195f, 3.515f, 4.06f, 3.575f, 4.06f)
                horizontalLineTo(12.28f)
                curveTo(12.34f, 4.06f, 12.389f, 4.195f, 12.389f, 4.363f)
                curveTo(12.389f, 4.53f, 12.34f, 4.666f, 12.28f, 4.666f)
                horizontalLineTo(3.575f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.048f, 4.301f)
                lineTo(12.553f, 3.656f)
                lineTo(13.448f, 4.301f)
                lineTo(12.553f, 4.963f)
                lineTo(12.048f, 4.301f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(3.575f, 6.666f)
                curveTo(3.515f, 6.666f, 3.466f, 6.53f, 3.466f, 6.363f)
                curveTo(3.466f, 6.195f, 3.515f, 6.06f, 3.575f, 6.06f)
                horizontalLineTo(12.28f)
                curveTo(12.34f, 6.06f, 12.389f, 6.195f, 12.389f, 6.363f)
                curveTo(12.389f, 6.53f, 12.34f, 6.666f, 12.28f, 6.666f)
                horizontalLineTo(3.575f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.048f, 6.301f)
                lineTo(12.553f, 5.656f)
                lineTo(13.448f, 6.301f)
                lineTo(12.553f, 6.963f)
                lineTo(12.048f, 6.301f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFD018))) {
                moveTo(2.173f, 7.911f)
                curveTo(2.092f, 7.911f, 2.027f, 7.757f, 2.027f, 7.567f)
                curveTo(2.027f, 7.377f, 2.092f, 7.223f, 2.173f, 7.223f)
                horizontalLineTo(13.845f)
                curveTo(13.925f, 7.223f, 13.99f, 7.377f, 13.99f, 7.567f)
                curveTo(13.99f, 7.757f, 13.925f, 7.911f, 13.845f, 7.911f)
                horizontalLineTo(2.173f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.409f, 6.026f)
                curveTo(4.409f, 6.026f, 5.829f, 3.036f, 7.861f, 3.036f)
                curveTo(9.893f, 3.036f, 11.362f, 6.026f, 11.362f, 6.026f)
                curveTo(11.362f, 6.026f, 9.569f, 8.977f, 7.885f, 8.977f)
                curveTo(6.202f, 8.977f, 4.409f, 6.026f, 4.409f, 6.026f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(4.409f, 6.026f)
                curveTo(4.409f, 6.026f, 5.829f, 3.036f, 7.861f, 3.036f)
                curveTo(9.893f, 3.036f, 11.362f, 6.026f, 11.362f, 6.026f)
                curveTo(11.362f, 6.026f, 9.569f, 8.977f, 7.885f, 8.977f)
                curveTo(6.202f, 8.977f, 4.409f, 6.026f, 4.409f, 6.026f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF272727)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.962f, 2.84f)
                curveTo(7.962f, 2.84f, 7.499f, 3.403f, 7.653f, 3.94f)
                curveTo(7.808f, 4.477f, 8.168f, 4.42f, 8.168f, 4.893f)
                curveTo(8.168f, 5.366f, 8.001f, 5.848f, 8.168f, 5.848f)
                curveTo(8.334f, 5.848f, 8.392f, 6.175f, 8.24f, 6.396f)
                curveTo(8.088f, 6.617f, 7.953f, 6.624f, 7.962f, 6.984f)
                curveTo(7.971f, 7.344f, 8.758f, 7.698f, 8.377f, 7.698f)
                curveTo(7.996f, 7.698f, 7.493f, 8.068f, 7.653f, 8.068f)
                curveTo(7.813f, 8.068f, 8.649f, 8.356f, 8.649f, 8.734f)
                curveTo(8.649f, 9.113f, 8.649f, 9.416f, 8.649f, 9.416f)
                horizontalLineTo(4.286f)
                verticalLineTo(2.84f)
                horizontalLineTo(7.962f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.91f, 4.962f)
                horizontalLineTo(5.692f)
                verticalLineTo(5.846f)
                horizontalLineTo(5.91f)
                verticalLineTo(4.962f)
                close()
                moveTo(6.55f, 4.962f)
                horizontalLineTo(6.333f)
                verticalLineTo(5.846f)
                horizontalLineTo(6.55f)
                verticalLineTo(4.962f)
                close()
                moveTo(6.013f, 4.962f)
                horizontalLineTo(6.23f)
                verticalLineTo(5.846f)
                horizontalLineTo(6.013f)
                verticalLineTo(4.962f)
                close()
                moveTo(6.871f, 4.962f)
                horizontalLineTo(6.653f)
                verticalLineTo(5.846f)
                horizontalLineTo(6.871f)
                verticalLineTo(4.962f)
                close()
                moveTo(6.974f, 4.962f)
                horizontalLineTo(7.191f)
                verticalLineTo(5.846f)
                horizontalLineTo(6.974f)
                verticalLineTo(4.962f)
                close()
                moveTo(7.511f, 4.962f)
                horizontalLineTo(7.294f)
                verticalLineTo(5.846f)
                horizontalLineTo(7.511f)
                verticalLineTo(4.962f)
                close()
                moveTo(5.692f, 6.231f)
                horizontalLineTo(5.91f)
                verticalLineTo(7.115f)
                horizontalLineTo(5.692f)
                verticalLineTo(6.231f)
                close()
                moveTo(6.55f, 6.231f)
                horizontalLineTo(6.333f)
                verticalLineTo(7.115f)
                horizontalLineTo(6.55f)
                verticalLineTo(6.231f)
                close()
                moveTo(6.013f, 6.231f)
                horizontalLineTo(6.23f)
                verticalLineTo(7.115f)
                horizontalLineTo(6.013f)
                verticalLineTo(6.231f)
                close()
                moveTo(6.871f, 6.231f)
                horizontalLineTo(6.653f)
                verticalLineTo(7.115f)
                horizontalLineTo(6.871f)
                verticalLineTo(6.231f)
                close()
                moveTo(6.974f, 6.231f)
                horizontalLineTo(7.191f)
                verticalLineTo(7.115f)
                horizontalLineTo(6.974f)
                verticalLineTo(6.231f)
                close()
                moveTo(7.511f, 6.231f)
                horizontalLineTo(7.294f)
                verticalLineTo(7.115f)
                horizontalLineTo(7.511f)
                verticalLineTo(6.231f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF272727)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.489f, 4.962f)
                horizontalLineTo(8.271f)
                verticalLineTo(5.846f)
                horizontalLineTo(8.489f)
                verticalLineTo(4.962f)
                close()
                moveTo(9.129f, 4.962f)
                horizontalLineTo(8.912f)
                verticalLineTo(5.846f)
                horizontalLineTo(9.129f)
                verticalLineTo(4.962f)
                close()
                moveTo(8.592f, 4.962f)
                horizontalLineTo(8.809f)
                verticalLineTo(5.846f)
                horizontalLineTo(8.592f)
                verticalLineTo(4.962f)
                close()
                moveTo(9.45f, 4.962f)
                horizontalLineTo(9.233f)
                verticalLineTo(5.846f)
                horizontalLineTo(9.45f)
                verticalLineTo(4.962f)
                close()
                moveTo(9.553f, 4.962f)
                horizontalLineTo(9.77f)
                verticalLineTo(5.846f)
                horizontalLineTo(9.553f)
                verticalLineTo(4.962f)
                close()
                moveTo(10.09f, 4.962f)
                horizontalLineTo(9.873f)
                verticalLineTo(5.846f)
                horizontalLineTo(10.09f)
                verticalLineTo(4.962f)
                close()
                moveTo(8.271f, 6.231f)
                horizontalLineTo(8.489f)
                verticalLineTo(7.115f)
                horizontalLineTo(8.271f)
                verticalLineTo(6.231f)
                close()
                moveTo(9.129f, 6.231f)
                horizontalLineTo(8.912f)
                verticalLineTo(7.115f)
                horizontalLineTo(9.129f)
                verticalLineTo(6.231f)
                close()
                moveTo(8.592f, 6.231f)
                horizontalLineTo(8.809f)
                verticalLineTo(7.115f)
                horizontalLineTo(8.592f)
                verticalLineTo(6.231f)
                close()
                moveTo(9.45f, 6.231f)
                horizontalLineTo(9.233f)
                verticalLineTo(7.115f)
                horizontalLineTo(9.45f)
                verticalLineTo(6.231f)
                close()
                moveTo(9.553f, 6.231f)
                horizontalLineTo(9.77f)
                verticalLineTo(7.115f)
                horizontalLineTo(9.553f)
                verticalLineTo(6.231f)
                close()
                moveTo(10.09f, 6.231f)
                horizontalLineTo(9.873f)
                verticalLineTo(7.115f)
                horizontalLineTo(10.09f)
                verticalLineTo(6.231f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF3D58DB)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.616f, 3.536f)
                curveTo(6.312f, 3.63f, 6.172f, 4.428f, 6.206f, 4.621f)
                curveTo(6.24f, 4.814f, 6.344f, 4.597f, 6.344f, 4.597f)
                curveTo(6.344f, 4.597f, 6.554f, 5.054f, 6.576f, 5.177f)
                curveTo(6.598f, 5.3f, 6.708f, 4.991f, 6.708f, 4.991f)
                curveTo(6.708f, 4.991f, 7.074f, 5.243f, 7.123f, 5.523f)
                curveTo(7.172f, 5.803f, 7.247f, 5.202f, 7.247f, 5.202f)
                lineTo(7.329f, 5.188f)
                lineTo(7.277f, 4.891f)
                lineTo(7.435f, 5.026f)
                lineTo(7.386f, 4.75f)
                curveTo(7.386f, 4.75f, 7.505f, 4.905f, 7.475f, 4.734f)
                curveTo(7.445f, 4.563f, 7.428f, 4.468f, 7.428f, 4.468f)
                lineTo(7.387f, 4.234f)
                lineTo(7.543f, 4.207f)
                curveTo(7.543f, 4.207f, 6.92f, 3.442f, 6.616f, 3.536f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFF3D58DB)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(13.044f, 6.848f)
            curveTo(12.728f, 6.888f, 12.453f, 7.65f, 12.453f, 7.845f)
            curveTo(12.453f, 8.041f, 12.592f, 7.845f, 12.592f, 7.845f)
            curveTo(12.592f, 7.845f, 12.72f, 8.333f, 12.72f, 8.458f)
            curveTo(12.72f, 8.583f, 12.883f, 8.297f, 12.883f, 8.297f)
            curveTo(12.883f, 8.297f, 13.198f, 8.608f, 13.198f, 8.893f)
            curveTo(13.198f, 9.178f, 13.376f, 8.599f, 13.376f, 8.599f)
            horizontalLineTo(13.46f)
            verticalLineTo(8.297f)
            lineTo(13.592f, 8.458f)
            verticalLineTo(8.177f)
            curveTo(13.592f, 8.177f, 13.682f, 8.351f, 13.682f, 8.177f)
            curveTo(13.682f, 8.004f, 13.682f, 7.907f, 13.682f, 7.907f)
            verticalLineTo(7.67f)
            horizontalLineTo(13.841f)
            curveTo(13.841f, 7.67f, 13.36f, 6.808f, 13.044f, 6.848f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF3D58DB)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(2.796f, 6.733f)
            curveTo(3.112f, 6.773f, 3.388f, 7.534f, 3.388f, 7.73f)
            curveTo(3.388f, 7.926f, 3.249f, 7.73f, 3.249f, 7.73f)
            curveTo(3.249f, 7.73f, 3.121f, 8.217f, 3.121f, 8.342f)
            curveTo(3.121f, 8.467f, 2.958f, 8.182f, 2.958f, 8.182f)
            curveTo(2.958f, 8.182f, 2.642f, 8.493f, 2.642f, 8.778f)
            curveTo(2.642f, 9.062f, 2.464f, 8.483f, 2.464f, 8.483f)
            horizontalLineTo(2.38f)
            verticalLineTo(8.182f)
            lineTo(2.249f, 8.342f)
            verticalLineTo(8.062f)
            curveTo(2.249f, 8.062f, 2.158f, 8.235f, 2.158f, 8.062f)
            curveTo(2.158f, 7.888f, 2.158f, 7.791f, 2.158f, 7.791f)
            verticalLineTo(7.554f)
            horizontalLineTo(2f)
            curveTo(2f, 7.554f, 2.48f, 6.693f, 2.796f, 6.733f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun EswatiniPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.Eswatini,
            contentDescription = "Eswatini Flag"
        )
    }
}
